
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IWsrPreviewWidgetProps,
  IWsrPreviewWidgetMapperProps,
  IWsrPreviewWidgetControllerProps,
  IWsrPreviewWidgetStateValues,
} from '../../../components/WsrPreviewWidget/WsrPreviewWidget.props';

export default withCompController<
  IWsrPreviewWidgetMapperProps,
  IWsrPreviewWidgetControllerProps,
  IWsrPreviewWidgetProps,
  IWsrPreviewWidgetStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
